import React, { useEffect } from 'react';
import FormInput from '../../Common/formInput';
import { Grid, Button, Box, Typography, Paper } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import currentUserSelector from '../../../selectors/currentUserSelector';
import { useDispatch, useSelector } from 'react-redux';
import { getdeleteIpAddress, updateUserDetailsInSettings, getUserDetailsData } from '../../../actions/get-user-details';
import CustomCheckbox from '../../Common/CustomCheckBox';

import Table from '@material-ui/core/Table';
import CircularProgress from '@material-ui/core/CircularProgress'
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Delete from '@material-ui/icons/Delete';

const headCells = [
    { id: 'ipAddress', label: 'Ip Address', minWidth: 100 },
    { id: 'action', label: 'Action', minWidth: 100 },
];

const useStyles = makeStyles(() => ({
    table: {
        // overflowY: 'scroll',
        // maxHeight: '20rem'
        border: '1px solid #08090A20'
    },
    tableContainer: {
        overflowY: 'auto',
        maxHeight: '60vh'
    }
}));

const StyledTableCell = withStyles({
    root: {
        padding: '0.5rem',
        textAlign: 'center',
        border: '1px solid #08090A20'
    }
})(TableCell);

const StyledTableCellHead = withStyles({
    root: {
        padding: '0.5rem',
        textAlign: 'center',
        border: '1px solid #08090A20',
        fontWeight: 600,
    }
})(TableCell);

export default function SecurityPolicyForm(props) {
    const [formValues, setFormValues] = React.useState({});
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [isLoading, setIsLoading] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [listData, setListData] = React.useState(props.listdata);
    const tableContainerRef = React.useRef(null);
    const currentUser = useSelector(currentUserSelector);
    const userDetailsData = useSelector(state => state.fetchUserDetails.data);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsLoading(true);
        dispatch(getUserDetailsData({ user_id: currentUser.user.id })).then(
            resp => setIsLoading(false)
        )
    }, [])

    useEffect(() => {
        if (tableContainerRef) {
            tableContainerRef.current.scroll({
                top: 0,
                behaviour: 'smooth'
            })
        }
    }, [rowsPerPage]);

    // React.useEffect(() => {
    //     console.log(" ++++++++++++ GeneralForm ++++++++ ", formValues);
    //     const { tf_email=false, tf_phone=false } = currentUser;
    //     setFormValues({ tf_email, tf_phone });
    //     console.log(" ++++++++++++ GeneralForm after Update ++++++++ ", formValues);
    // }, [currentUser]);

    // let rows = ['289.289.292.92', '289.289.292.109', '81.289.101.90', '10.289.292.90', 
    // '289.289.292.92', '289.289.292.109', '81.289.101.90', '10.289.292.90'];

    let rows = userDetailsData?.ip_list || [];

    // pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDelete = (ipAddress) => {
        dispatch(getdeleteIpAddress({ user_id: currentUser.user.id, ip: ipAddress }))
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    const onChangeHandler = (key, value) => {
        setFormValues({ ...formValues, [key]: value })
    }

    const handleSubmit = () => {
        const { tf_email, tf_phone } = formValues;
        const { id } = currentUser;
        dispatch(updateUserDetailsInSettings({ tf_email, tf_phone, user_id: id }));
    }

    const handleCancel = () => {
        const { tf_email = false, tf_phone = false } = currentUser;
        setFormValues({ tf_email, tf_phone });
    }

    const classes = useStyles();

    return (
        <Box>
            <Box>
                <TableContainer component={'div'} className={classes.tableContainer} ref={tableContainerRef}>
                    <Table stickyHeader className={classes.table} aria-label="IP list table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHead component='th'>IP Address</StyledTableCellHead>
                                {(Number(currentUser.userRole) === 1) && <StyledTableCellHead component='th' width="12%">Action</StyledTableCellHead>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? (
                                <TableRow >
                                    <StyledTableCell colSpan={6}>
                                        <Box display='flex' justifyContent='center' alignItems='center' padding='1rem'>
                                            <CircularProgress size={20} className={classes.progress} />
                                        </Box>
                                    </StyledTableCell>
                                </TableRow>) :
                                (Array.isArray(rows) && rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => row && (
                                    <TableRow>
                                        <StyledTableCell component='td'>
                                            {row}
                                        </StyledTableCell>
                                        {(Number(currentUser.userRole) === 1) &&
                                            <StyledTableCell width="12%" component='td'>
                                                {/* <Delete  onClick={()=> handleDelete(row)}/> */}
                                                <Button
                                                    disableRipple variant="text"
                                                    onClick={() => handleDelete(row)}
                                                    autoFocus>
                                                    <Delete />
                                                </Button>
                                            </StyledTableCell>}
                                    </TableRow>
                                ))
                                )}
                            {
                                !isLoading && emptyRows > 0 && (
                                    <TableRow style={{ height: '50%' }}>
                                        <StyledTableCell colSpan={6} />
                                    </TableRow>)
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                {/* <Box>
                    <Typography variant="subtitle2">Two Factor Authentication</Typography>
                    <Box style={{ display: 'flex', alignItems: 'center'}}>
                        <CustomCheckbox
                            onChange={(e) => onChangeHandler('tf_phone', e.target.checked, e)}
                            value={formValues['tf_phone'] || ''}
                            checked={Boolean(formValues['tf_phone']) || false}
                        />
                        <Typography variant="subtitle2" color="textSecondary">
                            {'Send code to Phone'}
                        </Typography>
                    </Box>
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <CustomCheckbox
                            onChange={(e) => onChangeHandler('tf_email', e.target.checked, e)}
                            value={formValues['tf_email'] || ''}
                            checked={Boolean(formValues['tf_email']) || false}
                        />
                        <Typography variant="subtitle2" color="textSecondary">
                            {'Send code to Email'}
                        </Typography>
                    </Box>
                    <Box display='flex'>
                        <Button onClick={handleCancel}>Cancel</Button>
                        <Button onClick={handleSubmit}>Submit</Button>
                    </Box>
                </Box> */}
            </Box>
        </Box>

    )
}